// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HRb0C1gZMJRRbVfZw3BK{height:100vh;background-color:#fff}", "",{"version":3,"sources":["webpack://./src/codebridge/FilePreview/styles/page-not-found.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA","sourcesContent":[".placeholderContainer {\n  height: 100vh;\n  background-color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"placeholderContainer": "HRb0C1gZMJRRbVfZw3BK"
};
export default ___CSS_LOADER_EXPORT___;
